// provides demonstration data for front-end while developing back end

const demoApprovals = () => Promise.resolve(demoApprovalsData);
const demoApprovalsData = [
      {role: "Firefighter",
      reason: "CAS is on fire",
      requestor: {
          name: "Stacey McElroy", id: "id"
      }, account: {
          name: "CAS Product", id: "29039211"}
      },
      {role: "Firefighter",
      reason: "My bank account is a little light",
      requestor: {
          name: "Felix Unger", id: "id2"
      }, account: {
          name: "Site Scraper Product", id: "2938252"}
      }
];

export {demoApprovals};



// WEBPACK FOOTER //
// ./src/approvals/demoWiring.js